import React from "react";
import { EmployersLayout } from "@/modules/employers/components/EmployersLayout";

export const Employers: React.FC = () => <EmployersLayout />;
